module.exports = __webpack_public_path__ + "media/images/new-ui-images/accordian-arrow-868b16cca6af9b926549e0b3dd28d8ab.svg";